import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import { withRouter } from 'react-router-dom';
import { push } from 'react-router-redux';
import axios from 'axios';

// Styles
import styles from './styles';

// Material UI
import { withStyles } from 'material-ui/styles';
import Typography from 'material-ui/Typography';
import Stepper, { Step, StepLabel, StepContent } from 'material-ui/Stepper';
import Button from 'material-ui/Button';
import Paper from 'material-ui/Paper';
import Input, { InputLabel } from 'material-ui/Input';
import Radio, { RadioGroup } from 'material-ui/Radio';
import { FormLabel, FormControl, FormControlLabel, FormHelperText } from 'material-ui/Form';

import {saveData} from './actions';

class Question1 extends Component {

  constructor(props){
    super(props);

    this.state = {
      value: "",
      showPopulation: false,
      popCount: "~",
    };
  }

  handleChange = (event, value) => {
     this.setState({ value });
  };

  onShowPopulation = () => {
    this.setState({
      showPopulation: true
    })
  }

  onApplyFilter() {

    //oar_low: 0,oar_high:10,age_low:0,age_high: 65,pref_age:59,income: 0, education: 0,pref_fans: 0
    this.props.saveData(0,10,0,75,0,0,0,0);
    this.props.changeRoute("/console/display/adhoc_filters/notifications")
  }

  render(){
    const { classes, theme, location } = this.props;
    const { showPopulation } = this.state;
    const label = 'Select distance you want';
    const content = 'What distance do you want from your zip code?';
    const defaultValue = 'Ex: 1310';

    return(
      <div className={classes.root}>
        <Typography type="body2" color="inherit" className={classes.flex}>
          1. Distance
        </Typography>
        <br/>
        <Typography>By default, the search is currently set to a 40 mile radius. Searching other distances is currently not supported.</Typography>
        <br />
        <FormControl aria-describedby="name-helper-text">
          <InputLabel htmlFor="name-helper">Zip Code</InputLabel>
          <Input value={64139} id="zip-code-helper" />
          <FormHelperText id="name-helper-text">Type in your zip code above.</FormHelperText>
          <br />
          <br />
          <Typography>Distance from Zip Code</Typography>
          {/*this.state.value*/}
          <RadioGroup aria-label="distance" name="distance" value="40" onChange={this.handleChange} className={classes.group}>
            <FormControlLabel className={classes.radioButton} value="5"  control={<Radio />} label="5 Miles" />
            <FormControlLabel className={classes.radioButton} value="10" control={<Radio />} label="10 Miles" />
            <FormControlLabel className={classes.radioButton} value="20" control={<Radio />} label="20 Miles" />
            <FormControlLabel className={classes.radioButton} value="30" control={<Radio />} label="30 Miles" />
            <FormControlLabel value="40" control={<Radio />} label="40 Miles" />
          </RadioGroup>
        </FormControl>
        <div className={classes.buttonNext}>
          <Button raised onClick={() => this.onApplyFilter()} color="primary" align="center" className={classes.button}>Apply Filter</Button>
          <Button raised onClick={() => this.props.changeRoute('/console/display/adhoc_filters')} color="primary" align="center" className={classes.button}>Select a different Filter</Button>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
    return {
        customer_number: state.customer.number,
        project_id: state.prefix.project_id,
        distance: state.distance
    };
}

function matchDispatchToProps(dispatch){
  return {
    saveData: bindActionCreators(saveData, dispatch),
    dispatch,
    changeRoute: (url) => dispatch(push(url)),
  }
}

export default withRouter(withStyles(styles, { withTheme: true })(connect(mapStateToProps, matchDispatchToProps)(Question1)));



// WEBPACK FOOTER //
// ./src/scenes/Dashboard/scenes/Home/scenes/Adhoc/scenes/Question1/index.js